import React, { Fragment, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import DialogBoxComponent from "../../../../components/DialogBoxComponent";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Stack, Typography } from "@mui/material";
import { useRiskAssessmentContext } from "../../../../context/RiskAssessment/RiskAssessmentContext";
import { AddThreatImport } from "../modal";
import { createImport, getThreatSourctImportList } from "../helper";
import { useUserContext } from "../../../../context/auth/UserContext";

// interface PolicyImportInterface {
//     policyID: number;
//     policyName: string;
//     policyContent: string;
//     version: string;
//     policyStatus: string;
//     approvalDate: Date;
// }

export const TsImport = (props: {
  openDialog: boolean;
  handleCancel: () => void;
  refreshList: () => void;
}) => {
  const { threatSourceList } = useRiskAssessmentContext();
  const { userId, companyProfileID } = useUserContext();

  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [importTsList, setImportTsList] = useState<any[]>([]);
  const [importTsListOrg, setImportTsListOrg] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [exsistingThreat, setExsistingThreat] = useState<any[]>([]);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openImportConfirmation: false,
    openSuccessDialogBox: false,
    openDeleteConfirmationDialog: false,
  });
  const handleCloseDialog = () => {
    if (dialogState.title !== "Error") {
      setDialogState({
        ...dialogState,
        openImportConfirmation: false,
        openSuccessDialogBox: false,
      });
      props.refreshList();
      handleClose();
    } else {
      setDialogState({
        ...dialogState,
        openImportConfirmation: false,
        openSuccessDialogBox: false,
      });
    }
  };

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectAll(false);
      setChecked([]);
    } else {
      setSelectAll(true);
      const newChecked = importTsList.map((ele) => ele.threatImportID);
      setChecked(newChecked);
    }
  };

  const handleClose = () => {
    if (props.handleCancel) {
      props.handleCancel();
    }
    setChecked([]);
    setSelectAll(false);
    setExsistingThreat([]);
    setImportTsList([]);
    setImportTsListOrg([]);
    setOpen(false);
  };

  const fetchTsImport = async () => {
    try {
      const res = await getThreatSourctImportList();
      const filteredRes = res.filter((resItem: any) => {
        return !threatSourceList.some(
          (existingItem: any) => existingItem.threatName === resItem.threatName
        );
      });

      setImportTsList(filteredRes);
      setImportTsListOrg(res);
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getSelectedImport = () => {
    return importTsList.filter((ele) => checked.includes(ele.threatImportID));
  };

  const handleImport = async () => {
    setIsLoading(true);
    const selectedImport = getSelectedImport();
    let hasError = false;
    const date = new Date();

    //Import new policy
    const payload: AddThreatImport[] = selectedImport.map((ele) => {
      return {
        threatName: ele.threatName,
        createDate: date,
        createdBy: userId,
        companyProfileID: companyProfileID,
        isDeleted: false,
        TemplateID: ele.threatImportID,
      };
    });
    const resImport = await createImport(payload);
    if (!resImport.succeeded) {
      hasError = true;
    }

    if (hasError) {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openImportConfirmation: false,
        openSuccessDialogBox: true,
        openDeleteConfirmationDialog: false,
      });
    } else {
      setDialogState({
        title: "Success",
        body: "Threat Sources successfully imported",
        action: "OK",
        actionCancel: "",
        openImportConfirmation: false,
        openSuccessDialogBox: true,
        openDeleteConfirmationDialog: false,
      });
    }
    setIsLoading(false);
  };

  // const handleDeleteClick = (item: any) => {
  //     // console.log("handleDeleteClick item", item);

  //     setDialogState({
  //         title: "Confirm",
  //         body: `Are you sure you want to delete ${item.folderName}`,
  //         action: "OK",
  //         actionCancel: "CANCEL",
  //         openDeleteConfirmationDialog: true,
  //         openSuccessDialogBox: false,
  //     })
  // }

  useEffect(() => {
    setOpen(props.openDialog);
    setIsLoading(true);
    if (props.openDialog) {
      // console.log("ThreatSourceList", threatSourceList);

      fetchTsImport();
    }
  }, [props.openDialog]);

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} keepMounted>
        <DialogTitle sx={{ fontSize: "1.1rem" }}>
          Import Threat Sources
        </DialogTitle>
        <DialogContent>
          {importTsList.length > 0 ? (
            <Stack direction="row" sx={{ mx: 2 }}>
              <Checkbox
                size="small"
                edge="start"
                checked={selectAll}
                onChange={handleSelectAll}
                tabIndex={-1}
                disableRipple
                sx={{ p: 0, mr: 3 }}
              />
              <span>Select All</span>
            </Stack>
          ) : null}

          <DialogContentText sx={{ height: "300px", overflowY: "scroll" }}>
            <List sx={{ width: "300px", bgcolor: "background.paper" }}>
              {!isLoading ? (
                importTsListOrg.length > 0 ? (
                  importTsList.length > 0 ? (
                    importTsList
                      .sort((a, b) => {
                        const nameA = a.threatName || "";
                        const nameB = b.threatName || "";
                        return nameA.localeCompare(nameB);
                      })
                      .map((ele) => {
                        const labelId = `checkbox-list-label-${ele}`;

                        return (
                          <ListItem
                            key={ele.threatImportID}
                            disablePadding
                            disableGutters
                          >
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(ele.threatImportID)}
                              dense
                            >
                              <ListItemIcon sx={{ minWidth: "2rem" }}>
                                <Checkbox
                                  size="small"
                                  edge="start"
                                  checked={
                                    checked.indexOf(ele.threatImportID) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                  sx={{ p: 0 }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={ele.threatName}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })
                  ) : (
                    <Typography textAlign="center">
                      All the threat sources are already imported.
                    </Typography>
                  )
                ) : (
                  <Typography textAlign="center">
                    No threat source to import
                  </Typography>
                )
              ) : (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress />
                </Box>
              )}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0.5rem 1.5rem" }}>
          <Button
            size="small"
            variant="contained"
            className="table-btn"
            disabled={isLoading}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            className="table-btn"
            disabled={checked.length === 0 || isLoading}
            onClick={handleImport}
          >
            Import
          </Button>
        </DialogActions>
      </Dialog>
      {
        //Confirmation
        <DialogBoxComponent
          openDialogBox={dialogState.openImportConfirmation}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleImport}
          handleCancel={handleCloseDialog}
        />
      }
      {
        //success
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
